export const NavList = [
  {
    navName: "Home",
    navLink: "/mvp",
    navLinkIdentifier: "home",
    navId: "home",
  },
  {
    navName: "Vendor Onboarding",
    navLink: "/boarding/vendor/company",
    navLinkIdentifier: "updateProfile",
    navId: "vendor",
  },
  {
    navName: "My Dashboard",
    navLink: "/dashboard",
    navLinkIdentifier: "dashboard",
    navId: "dashboard",
  },
  {
    navName: "Document Library",
    navLink: "/document-library",
    navLinkIdentifier: "documentLibrary",
    navId: "document-library",
  },
  {
    navName: "Shipping",
    navLink: "/boarding/shipping",
    navLinkIdentifier: "shipping",
    navId: "shipping",
  },
  {
    navName: "Seller Hub",
    navLink: "/sellerreports",
    navLinkIdentifier: "sellerreports",
    navId: "sellerreports",
  },
  {
    navName: "User Management",
    navLink: "/manageusers",
    navLinkIdentifier: "manageusers",
    navId: "manageusers",
  },
  {
    navName: "Publish Notification",
    navLink: "/notifications/publish",
    navLinkIdentifier: "publishNotification",
    navId: "publishNotification",
  }
];

export const mtoUserNavList = [
  {
    navName: "Home",
    navLink: "/mvp",
    navLinkIdentifier: "home",
    navId: "home",
  },
  {
    navName: "Publish Notification",
    navLink: "/notifications/publish",
    navLinkIdentifier: "publishNotification",
    navId: "publishNotification",
  },
];

export const SellerCentralNavSubList = [
  // {
  //   navName: "Insights for Action",
  //   navLink: "/sellerreports/reports",
  //   navLinkIdentifier: "sellerreports",
  //   navId: "reports",
  // },
  {
    navName: "Manage Access",
    navLink: "/sellerreports/managereports",
    navLinkIdentifier: "sellerreports",
    navId: "managereports",
  },
];
